var _style, _path, _path2, _path3, _circle, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n\t.st3{fill:#338AF3;}\n\t.st4{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,256C0,114.6,114.6,0,256,0s256,114.6,256,256l-256,22.3L0,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,384c44.3,76.5,127,128,221.7,128s177.5-51.5,221.7-128L256,367.3L34.3,384z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M477.7,384c21.8-37.7,34.3-81.4,34.3-128H0c0,46.6,12.5,90.3,34.3,128H477.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 89
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,311.7c-30.7,0-55.7-25-55.7-55.7v-33.4c0-30.7,25-55.7,55.7-55.7s55.7,25,55.7,55.7V256 C311.7,286.7,286.7,311.7,256,311.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M345,122.4h-66.8c0-12.3-10-22.3-22.3-22.3s-22.3,10-22.3,22.3H167c0,12.3,10.7,22.3,23,22.3h-0.7c0,12.3,10,22.3,22.3,22.3 c0,12.3,10,22.3,22.3,22.3h44.5c12.3,0,22.3-10,22.3-22.3c12.3,0,22.3-10,22.3-22.3H322C334.3,144.7,345,134.7,345,122.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.55e0cc92c5e674296f0ab2690dd4ddee.svg";
export { ForwardRef as ReactComponent };